module.exports = __webpack_public_path__ + "media/images/favicons/favicon-96x96-5afbbaa2d618403dea3a84288505ba03.png";